import { Check } from 'lucide-react';

import { PRICING_TIERS } from '@/data/billing';

export default function TierChooser({
  value,
  onChange,
  disabled,
}: {
  value: string;
  onChange: (slug: string) => void;
  disabled?: boolean;
}) {
  return (
    <div className="grid gap-3 sm:grid-cols-3" data-testid="tier-chooser">
      {PRICING_TIERS.map((tier) => {
        const chosen = value === tier.slug;
        return (
          <button
            key={tier.slug}
            type="button"
            disabled={disabled}
            onClick={() => onChange(tier.slug)}
            aria-pressed={chosen}
            data-testid={`tier-option-${tier.slug}`}
            className={`flex h-full flex-col rounded-xl border p-4 text-left transition-colors disabled:opacity-60 ${
              chosen
                ? 'border-primary bg-primary/5 ring-1 ring-primary'
                : 'hover:border-foreground/30 hover:bg-muted/40'
            }`}
          >
            <div className="flex items-start justify-between gap-2">
              <span className="text-sm font-semibold">{tier.name}</span>
              <span
                className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border ${
                  chosen ? 'border-primary bg-primary text-primary-foreground' : 'border-muted-foreground/30'
                }`}
              >
                {chosen && <Check className="h-3 w-3" />}
              </span>
            </div>
            <p className="mt-2 text-xs leading-relaxed text-muted-foreground">{tier.blurb}</p>
            <ul className="mt-3 flex-1 space-y-1.5">
              {tier.highlights.map((item) => (
                <li key={item} className="flex items-start gap-1.5 text-xs">
                  <Check className={`mt-0.5 h-3 w-3 shrink-0 ${chosen ? 'text-primary' : 'text-muted-foreground'}`} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </button>
        );
      })}
    </div>
  );
}
